import { audioContext, masterTrack } from '../../webAudio/audioContext';

const keyboardCompressor = new DynamicsCompressorNode(audioContext);

keyboardCompressor.connect(masterTrack.in);

export { keyboardCompressor };
